import type { NavigateFunction } from 'react-router-dom';
import type { AthleteTeamContext, TeamContext, ViewContext } from '../contexts/RoleContext';
import type { TeamMemberRole } from '../types/database';

export interface MyTeamsMenuItem {
  id: string;
  slug: string;
  name: string;
  logoUrl?: string | null;
  canManage: boolean;
  role?: TeamMemberRole;
}

export function buildMyTeamsMenuItems(
  availableTeams: TeamContext[],
  availableAthleteTeams: AthleteTeamContext[],
): MyTeamsMenuItem[] {
  const items: MyTeamsMenuItem[] = availableTeams.map((team) => ({
    id: team.id,
    slug: team.slug,
    name: team.name,
    logoUrl: team.logoUrl,
    canManage: true,
    role: team.role,
  }));
  const managerIds = new Set(availableTeams.map((team) => team.id));
  for (const team of availableAthleteTeams) {
    if (!managerIds.has(team.id)) {
      items.push({
        id: team.id,
        slug: team.slug,
        name: team.name,
        logoUrl: team.logoUrl,
        canManage: false,
      });
    }
  }
  return items;
}

export function navigateToMyTeam(
  team: MyTeamsMenuItem,
  setActiveContext: (context: ViewContext) => void,
  navigate: NavigateFunction,
): void {
  if (team.canManage && team.role) {
    setActiveContext({
      type: 'coach',
      teamId: team.id,
      teamName: team.name,
      role: team.role,
    });
    navigate('/my-team');
    return;
  }
  navigate(`/teams/${team.slug}`);
}
